// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { AiApiSpec_emptySchema } from './AiApiSpec_emptySchema';

export const AiApiSpec_addToModelTrainingQueueQueryParamsSchema = z.object({
  tic_user_id: z.coerce.string(),
  timely_account_id: z.number(),
  timely_user_id: z.number(),
  since: z.optional(z.coerce.string()),
  to: z.optional(z.coerce.string()),
});

/**
 * @description 200 response
 */
export const AiApiSpec_addToModelTrainingQueue200Schema = z.lazy(() => AiApiSpec_emptySchema);

export const AiApiSpec_addToModelTrainingQueueQueryResponseSchema = z.lazy(() => AiApiSpec_addToModelTrainingQueue200Schema);
